export enum KpiEnum {
  OFFER_LINK_COUNT = 1 , //  отчитаме след отваряне на линк от имейл
  LEAD_MODAL_WINDOW = 2, //  отчитаме при стъпване на екран нещо се обърка
  LEAD_SIDE_BAR = 3,  //     отчитаме само при натиснат бутон ИЗПРАТИ от диалогов прозорец Обадете ми се
  LEAD_QUOTE_PAGE = 4, //    екран пакети само ако иска да излезне от приложението
  LEAD_PRE_QUOTE = 5, //     екран преди пакети само ако иска да излезне от приложението
  OFFER_TURNED_POLICY_COUNT = 9, // отчитаме само успешно издадени полици от имейл
  NEW_PROFILE_AFTER_QB = 10, // само след успешно направена автоматична регистрация финален екран
  NEW_PROFILE_CP = 11 // ?
}
